// Centralized config for Apps menu/sidebar
export type AppsMenuSection = {
  header?: string;
  items: AppsMenuItem[];
};

export type AppsMenuItem = {
  title: string;
  eventKey?: string; // for Tab/Dropdown navigation
  external?: boolean;
  link: string; // can be /apps?tab=... or external url
  showExternalText?: boolean;
  requiredScope?: string;
  requiredFeatureFlag?: string;
  hideIfNoPermission?: boolean;
};

export const appsMenuConfig: AppsMenuSection[] = [
  {
    header: "Pricing",
    items: [
      {
        title: "Pricing Dashboard Portal",
        eventKey: "pricing",
        link: "/apps?tab=pricing",
      },
    ],
  },
  {
    header: "Finance",
    items: [
      {
        title: "Finance TDB Upload",
        eventKey: "finance-tdb-upload",
        link: "/apps?tab=finance-tdb-upload",
        requiredScope: "upload:finance-data",
      },
    ],
  },
  {
    header: "Image Tools",
    items: [
      {
        title: "Get Image URLs from page",
        eventKey: "image-urls-from-page",
        link: "/apps?tab=image-urls-from-page",
      },
      {
        title: "Image Retrieval Tool",
        eventKey: "image-retrieval-tool",
        link: "/apps?tab=image-retrieval-tool",
        requiredScope: "use:image-downloader",
        requiredFeatureFlag: "imageRetrievalTool",
      },
      {
        title: "Crop Image",
        eventKey: "cropping-tool",
        link: "/apps?tab=cropping-tool",
      },
      {
        title: "Image Upload Tool",
        link: "/image-upload-tool",
        external: true,
      },
    ],
  },
  {
    header: "Other Tools",
    items: [
      {
        title: "PM Grading Tool",
        link: "/pm-grading",
        external: true,
        showExternalText: false,
      },
      {
        title: "Cube Estimator",
        eventKey: "cube-estimator",
        link: "/apps?tab=cube-estimator",
      },
      {
        title: "Item Location",
        link: "/item-location",
        external: true,
      },
    ],
  },
  {
    header: "External Links",
    items: [
      {
        title: "Cluvio",
        link: "https://app.cluvio.com/dashboards",
        external: true,
        showExternalText: false,
      },
    ],
  },
  {
    header: "Old Tools",
    items: [
      {
        title: "Stock Images (old)",
        eventKey: "pm-image",
        link: "/apps?tab=pm-image",
      },
      {
        title: "Outbound Auction Pallet Scanner (old)",
        eventKey: "pallet-scanner",
        link: "/apps?tab=pallet-scanner",
      },
    ],
  },
];
